import script from "./PlayerAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PlayerAvatar.vue?vue&type=style&index=0&id=711ddeb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711ddeb6"]])

export default __exports__